import { http } from 'http';

export default {
  sendSuggestion: (suggestion, email) => {
    http.post('/webh/formdata', {
      app: 'popupstore',
      subject: '[POPUPSTORE] Vehículo sugerido por cliente',
      content: suggestion,
      email
    });
  }
};
